if (!customElements.get('rating-summary')) {
  class RatingSummary extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.rating-summary__trigger');
      if (!this.trigger) return;

      this.onTriggerClick = this.scrollToReviews.bind(this);
      this.trigger.addEventListener('click', this.onTriggerClick);
    }

    disconnectedCallback() {
      if (this.trigger) {
        this.trigger.removeEventListener('click', this.onTriggerClick);
      }
    }

    scrollToReviews() {
      var ownSection = this.closest('.shopify-section');
      var allSections = document.querySelectorAll('.shopify-section');
      var candidates = [];

      allSections.forEach(function (el) {
        var classes = el.className || '';
        if (classes.indexOf('shopify-section-group-header-group') !== -1) return;
        if (classes.indexOf('shopify-section-group-footer-group') !== -1) return;
        if (el === ownSection) return;
        candidates.push(el);
      });

      if (!candidates.length) return;

      var target = candidates[candidates.length - 1];
      var headerOffset = this.getHeaderOffset();
      var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth',
      });

      if (typeof target.focus === 'function') {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }

    getHeaderOffset() {
      var value = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      var parsed = parseInt(value, 10);
      return isNaN(parsed) ? 0 : parsed;
    }
  }

  customElements.define('rating-summary', RatingSummary);
}